'use client';

import { Link as ReactLink } from 'react-router-dom';

import { convertInternalLink } from '../../common/convertInternalLink';

import * as style from './style.module.css';


const Action = ({ action = false, target = '_blank', className = '', ...props }) => {
  const computedClassname = `${style.action} ${className}`;
  const dest = Array.isArray(action) ? action.map(convertInternalLink) : [convertInternalLink(action)];
  const actionText = dest.find(e => typeof e === 'string') || null;
  const actionFunction = dest.some(e => typeof e === 'function') ? () => {
    const funcs = dest.filter(e => typeof e === 'function');
    for (const func of funcs) {
      func();
    }
    return true;
  } : null;
  const onClickProps = actionFunction !== null ? { onClick: actionFunction } : {};


  // Relative link
  if (actionText !== null && (actionText[0] === '/' || actionText[0] === '?')) {
    return <ReactLink className={computedClassname} to={actionText} {...onClickProps} {...props} />;
  }

  // Email
  if (actionText !== null && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,25})+$/.test(actionText)) {
    return <a className={computedClassname} href={`mailto:${actionText}`} rel="noopener noreferrer"  {...onClickProps} {...props} />;
  }

  // Anchor
  if (actionText !== null && actionText[0] === '#') {
    return <a className={computedClassname} href={actionText}  {...onClickProps} {...props} />;
  }

  // Full url
  if (actionText !== null && actionText[0] !== '/') {
    return <a className={computedClassname} href={actionText} rel="noopener noreferrer" {...(target ? { target } : {})}  {...onClickProps} {...props} />;
  }

  // Function
  if (actionFunction !== null) {
    return <span className={computedClassname} onClick={actionFunction}  {...onClickProps} {...props} />;
  }

  return <span className={`${style.action} ${style.noaction} ${className}`} {...props} />;
};

export default Action;
